export default __webpack_public_path__ + "static/media/4.ac1f6c2a.png";